// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DefineChangeStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type DefineChangeStepQuery = { __typename?: 'Query', enumDetails: { __typename?: 'AllEnumDetails', changeEventWorkflow: Array<{ __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow, name: string, description: string }> } };


export const DefineChangeStepDocument = gql`
    query DefineChangeStep {
  enumDetails {
    changeEventWorkflow {
      code
      name
      description
    }
  }
}
    `;

/**
 * __useDefineChangeStepQuery__
 *
 * To run a query within a React component, call `useDefineChangeStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefineChangeStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefineChangeStepQuery({
 *   variables: {
 *   },
 * });
 */
export function useDefineChangeStepQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DefineChangeStepQuery, DefineChangeStepQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DefineChangeStepQuery, DefineChangeStepQueryVariables>(DefineChangeStepDocument, options);
      }
export function useDefineChangeStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DefineChangeStepQuery, DefineChangeStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DefineChangeStepQuery, DefineChangeStepQueryVariables>(DefineChangeStepDocument, options);
        }
// @ts-ignore
export function useDefineChangeStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DefineChangeStepQuery, DefineChangeStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineChangeStepQuery, DefineChangeStepQueryVariables>;
export function useDefineChangeStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineChangeStepQuery, DefineChangeStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DefineChangeStepQuery | undefined, DefineChangeStepQueryVariables>;
export function useDefineChangeStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DefineChangeStepQuery, DefineChangeStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DefineChangeStepQuery, DefineChangeStepQueryVariables>(DefineChangeStepDocument, options);
        }
export type DefineChangeStepQueryHookResult = ReturnType<typeof useDefineChangeStepQuery>;
export type DefineChangeStepLazyQueryHookResult = ReturnType<typeof useDefineChangeStepLazyQuery>;
export type DefineChangeStepSuspenseQueryHookResult = ReturnType<typeof useDefineChangeStepSuspenseQuery>;
export type DefineChangeStepQueryResult = ApolloReactCommon.QueryResult<DefineChangeStepQuery, DefineChangeStepQueryVariables>;